export default class Point implements PointType {
	constructor(public x: number, public y: number) {}
}
